import { render, staticRenderFns } from "./advanced-package.vue?vue&type=template&id=462b3bd2&scoped=true&"
import script from "./advanced-package.vue?vue&type=script&lang=js&"
export * from "./advanced-package.vue?vue&type=script&lang=js&"
import style0 from "./advanced-package.vue?vue&type=style&index=0&id=462b3bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b3bd2",
  null
  
)

export default component.exports